import React from 'react';
import { useState } from "react";
import { useNavigate } from "react-router-dom";

import axios from "../axios";
import { Apps } from "../api/api";

import Dashboard from "../Dashboard";
import {
  Button,
  Grid,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableRow,
} from "@mui/material";

export default function AppCreate() {
  const navigation = useNavigate();
  const [app, setApp] = useState<Apps>({});

  const handleCreate = () => {
    console.log("Create");
    axios
      .post("/apps", app)
      .then((res) => {
        console.log("post result:" + res);
        navigation("/apps");
      })
      .catch((err) => {
        alert(err.response.data.message);
      });
  };

  const handleChangeServiceId = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ): void => {
    setApp({ ...app, service_id: event.target.value });
  };

  const handleChangeAppId = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ): void => {
    setApp({ ...app, app_id: event.target.value });
  };

  const handleChangeAppName = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ): void => {
    setApp({ ...app, app_name: event.target.value });
  };

  const handleChangeAppVersion = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ): void => {
    setApp({ ...app, app_version: event.target.value });
  };

  const handleChangeMemo = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ): void => {
    setApp({ ...app, memo: event.target.value });
  };

  return (
    <Dashboard title="アプリ登録">
      <Table >
        <TableBody>
          <TableRow>
            <TableCell>
              <TextField
                label="サービスID"
                variant="outlined"
                required
                fullWidth
                value={app.service_id}
                onChange={handleChangeServiceId}
              />
            </TableCell>
          </TableRow>
        </TableBody>
        <TableBody>
          <TableRow>
            <TableCell>
              <TextField
                label="アプリID"
                variant="outlined"
                required
                fullWidth
                value={app.app_id}
                onChange={handleChangeAppId}
              />
            </TableCell>
          </TableRow>
        </TableBody>
        <TableBody>
          <TableRow>
            <TableCell>
              <TextField
                label="アプリ名"
                variant="outlined"
                required
                fullWidth
                value={app.app_name}
                onChange={handleChangeAppName}
              />
            </TableCell>
          </TableRow>
        </TableBody>
        <TableBody>
          <TableRow>
            <TableCell>
              <TextField
                label="アプリバージョン"
                variant="outlined"
                required
                fullWidth
                value={app.app_version}
                onChange={handleChangeAppVersion}
              />
            </TableCell>
          </TableRow>
        </TableBody>
        <TableBody>
          <TableRow>
            <TableCell>
              <TextField
                label="備考"
                variant="outlined"
                required
                multiline
                fullWidth
                value={app.memo}
                onChange={handleChangeMemo}
              />
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
      <br/>
      <Grid item xs={12}>
        <Button color="primary" variant="contained" onClick={handleCreate} sx={{ m: 1 }}>
          CREATE
        </Button>
      </Grid>
    </Dashboard>
  );
}
